import React, { useState } from "react"
import { motion } from "framer-motion"
import {Save} from 'lucide-react'
import { useGuias } from "../context/GuiasContext"
import toast from "react-hot-toast"

export default function CadastrarCemiterio() {
  const { addCemiterio } = useGuias()
  const [formData, setFormData] = useState({
    nome: "",
    codigo: "",
    endereco: "",
    latitude: "",
    longitude: ""
  })

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!formData.nome || !formData.codigo || !formData.endereco) {
      toast.error("Preencha todos os campos obrigatórios")
      return
    }

    // Validar coordenadas se fornecidas
    if ((formData.latitude && !formData.longitude) || (!formData.latitude && formData.longitude)) {
      toast.error("Preencha ambas latitude e longitude ou deixe ambas vazias")
      return
    }

    await addCemiterio(formData)
    
    // Limpar formulário
    setFormData({
      nome: "",
      codigo: "",
      endereco: "",
      latitude: "",
      longitude: ""
    })
  }

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white rounded-xl shadow-lg p-6 border border-gray-200"
      >
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Cadastrar Cemitério</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="w-48">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Código *
            </label>
            <input
              type="text"
              name="codigo"
              value={formData.codigo}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004161] focus:border-transparent"
              placeholder="Ex: CEM001"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Nome do Cemitério *
            </label>
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004161] focus:border-transparent"
              placeholder="Ex: Cemitério Municipal São José"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Endereço *
            </label>
            <input
              type="text"
              name="endereco"
              value={formData.endereco}
              onChange={handleInputChange}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004161] focus:border-transparent"
              placeholder="Ex: Rua Principal, s/n - Centro"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Geolocalização (Opcional)
            </label>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs text-gray-600 mb-1">Latitude</label>
                <input
                  type="text"
                  name="latitude"
                  value={formData.latitude}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004161] focus:border-transparent"
                  placeholder="Ex: -6.123456"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Longitude</label>
                <input
                  type="text"
                  name="longitude"
                  value={formData.longitude}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#004161] focus:border-transparent"
                  placeholder="Ex: -37.123456"
                />
              </div>
            </div>
          </div>

          {formData.latitude && formData.longitude && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Visualização no Mapa
              </label>
              <div className="w-full h-64 rounded-lg overflow-hidden border-2 border-gray-300">
                <iframe
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  src={`https://www.google.com/maps?q=${formData.latitude},${formData.longitude}&hl=pt-BR&z=15&output=embed`}
                />
              </div>
            </div>
          )}

          <div className="flex justify-end pt-4">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              type="submit"
              className="flex items-center gap-2 px-6 py-3 bg-[#004161] text-white rounded-lg hover:bg-[#005580] transition-colors shadow-lg"
            >
              <Save className="w-5 h-5" />
              Cadastrar Cemitério
            </motion.button>
          </div>
        </form>
      </motion.div>
    </div>
  )
}
